import { api } from "../../http";

async function PutDataItem(id,data) {
  try {
    
    const resp = await api.put(`/items/${id}`,data);
  
    return resp;

  } catch (e) {
    console.log(e.message);
  }
}

export { PutDataItem };
